<!--
 by:wangyingyu
 2020.6.18
-->
<template>
    <div class="textarea_box">
        <div
            id="textarea_content"
            class="text"
            ref="textarea"
            v-html="innerText"
            maxlength="5000"
            :contenteditable="canEdit"
            @focus="textareafoucs"
            @paste="handlePaste"
            @blur="resetpos"
            @input="changeText"
            @keydown.enter="listen"
            @click="closeexpression"
        ></div>
    </div>
</template>
<script>
export default {
    name: "editDiv",
    props: {
        talkvaltime:{
            type: Number,
            default: ""
        },
        talkval: {
            type: String,
            default: ""
        },
        canEdit: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            innerText: '',
            isLocked: false,
            isFistTime: true
        }
    },
    watch: {
        talkvaltime() {
            console.log("value", this.talkval,this.talkvaltime);
            document.querySelector('#textarea_content').focus()
            this.insertHtmlAtCaret(this.talkval)
        },
        isLocked() {
            this.innerText = '';
            console.log("isLocked", this.innerText);
        }
    },
    mounted(){
        
    },
    methods: {
        clearval(){
            this.innerText = ''
            this.$refs.textarea.innerHTML = ''
            console.log('清除输入框',this.innerText)
        },
        // 获得焦点
        textareafoucs(){
            this.isLocked = true
        },
        dragenter(){
            this.$emit('dragenter')
        },
        // 关闭表情
        closeexpression(){
            this.$emit('closeexpression')
        },
        // 内容变化
        changeText() {
            console.log(this.$refs,'this.$refs')
            this.$emit("input", this.$refs.textarea.innerHTML);
        },
        //回车禁止换行
        listen(event) {
            if (event.keyCode === 13) {
                event.preventDefault() // 阻止浏览器默认换行操作
                // 发送文本
                this.$emit("listen");
                return false
            }
        },
        keepLastIndex(obj) {
            console.log(obj);
            console.log(window.getSelection);
            console.log(document.selection);
            if (window.getSelection) {
                // ie11 10 9 ff safari
                obj.focus(); // 解决ff不获取焦点无法定位问题
                let range = window.getSelection(); // 创建range
                range.selectAllChildren(obj); // range 选择obj下所有子内容
                range.collapseToEnd(); // 光标移至最后
            } else if (document.selection) {
                // ie10 9 8 7 6 5
                let range = document.selection.createRange(); // 创建选择对象
                // var range = document.body.createTextRange();
                range.moveToElementText(obj); // range定位到obj
                range.collapse(false); // 光标移至最后
                range.select();
            }
        },
        insertHtmlAtCaret(html) {
            let sel, range;
            if (window.getSelection) {
                // IE9 and non-IE
              sel = window.getSelection();
              console.log(sel,'selsel')
              if (sel.getRangeAt && sel.rangeCount) {
                  range = sel.getRangeAt(0);
                  range.deleteContents();
                  // Range.createContextualFragment() would be useful here but is
                  // non-standard and not supported in all browsers (IE9, for one)
                  let el = document.createElement("div");
                  el.innerHTML = html;
                  console.log(el.firstChild, "el.firstChild");
                  let frag = document.createDocumentFragment(),
                      node,
                      lastNode;
                  while ((node = el.firstChild)) {
                      lastNode = frag.appendChild(node);
                  }
                  range.insertNode(frag);

                  // Preserve the selection
                  if (lastNode) {
                      range = range.cloneRange();
                      range.setStartAfter(lastNode);
                      range.collapse(true);
                      sel.removeAllRanges();
                      sel.addRange(range);
                  }
              }
            } else if ( document.selection && document.selection.type != "Control" ) {
                // IE < 9
                document.selection.createRange().pasteHTML(html);
            }
            this.$emit("input", this.$refs.textarea.innerHTML);
        },
        // 记录光标位置
        resetpos() {
            let elInput = this.$refs.textarea;
            let startPos = elInput.selectionStart;
            let endPos = elInput.selectionEnd;
            this.startPos = startPos;
            this.endPos = endPos;
            this.isLocked = true;
            // console.log(startPos, endPos, elInput);
        },
        handlePaste(e) {
            e.preventDefault();
            let text;
            let clp = (e.originalEvent || e).clipboardData;
            if (clp === undefined || clp === null) {
              text = window.clipboardData.getData("text") || "";
              if (text !== "") {
                if (window.getSelection) {
                  let newNode = document.createElement("span");
                  newNode.innerHTML = text;
                  window.getSelection().getRangeAt(0).insertNode(newNode);
                } else {
                  document.selection.createRange().pasteHTML(text);
                }
              }
              this.imgInit(window.clipboardData.items)
            } else {
              text = clp.getData('text/plain') || "";
              if (text !== "") {
                document.execCommand('insertText', false, text);
              }
              this.imgInit(clp.items)
            }
        },
        imgInit(items) {
            console.log(items,'imgInit')
          let file = null;
          if (!items || items.length === 0) {
            //   this.$message.error("当前浏览器不支持本地");
              return;
          }
          // 搜索剪切板items
          for (let i = 0; i < items.length; i++) {
              console.log(items[i],'imgInit')
              if (items[i].type.indexOf("image") !== -1) {
                  file = items[i].getAsFile();
                  break;
              }
          }
          if (!file) {
            //   this.$toast('只支持图片粘贴')
              return;
          }
          if(file.size > 25 * 1024 *1024){
              this.$toast('图片不能大于25M')
              return
          }
          console.log(file)
          // 此时file就是我们的剪切板中的图片对象
          // 如果需要预览，可以执行下面代码
          const reader = new FileReader();
          reader.onload = event => {
              this.insertHtmlAtCaret(`<img data-name="${file.name}" data-type="${file.type}" style="max-width: 120px;max-height: 214px;" src="${event.target.result}">`)
          };
          reader.readAsDataURL(file);
          this.file = file;
      }
    }
};
</script>
<style lang="less" scoped>
.textarea_box {
    height: calc(100% - 100px);
    .text {
        padding:0 10px 10px;
        height: calc(100% - 10px);
        overflow-y: auto;
        word-break: break-all;
        &:focus {
            outline: none;
        }
        img {
            max-width: 120px;
            max-height: 214px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/textareaModel.vue